import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type AlertType = 'error' | 'success';

export interface AlertState {
  message: string | null;
  type: AlertType | null;
  open: boolean;
}

const initialState: AlertState = {
  message: null,
  type: null,
  open: false,
};

const alertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    showAlert(state, action: PayloadAction<{ message: string; type: AlertType }>) {
      state.message = action.payload.message;
      state.type = action.payload.type;
      state.open = true;
    },
    clearAlert(state) {
      state.message = null;
      state.type = null;
      state.open = false;
    },
  },
});

export const { showAlert, clearAlert } = alertSlice.actions;
export default alertSlice.reducer;
export const selectAlertState = (state: any) => state.alert;
